/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ChargerMeterValueDto } from "./ChargerMeterValueDto";
import {
    ChargerMeterValueDtoFromJSON,
    ChargerMeterValueDtoFromJSONTyped,
    ChargerMeterValueDtoToJSON,
} from "./ChargerMeterValueDto";

/**
 *
 * @export
 * @interface TransactionMeterValuesResponse
 */
export interface TransactionMeterValuesResponse {
    /**
     *
     * @type {Array<ChargerMeterValueDto>}
     * @memberof TransactionMeterValuesResponse
     */
    meterValues?: Array<ChargerMeterValueDto>;
    /**
     *
     * @type {string}
     * @memberof TransactionMeterValuesResponse
     */
    nextCursor?: string;
}

/**
 * Check if a given object implements the TransactionMeterValuesResponse interface.
 */
export function instanceOfTransactionMeterValuesResponse(
    value: object,
): value is TransactionMeterValuesResponse {
    return true;
}

export function TransactionMeterValuesResponseFromJSON(
    json: any,
): TransactionMeterValuesResponse {
    return TransactionMeterValuesResponseFromJSONTyped(json, false);
}

export function TransactionMeterValuesResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TransactionMeterValuesResponse {
    if (json == null) {
        return json;
    }
    return {
        meterValues:
            json["meterValues"] == null
                ? undefined
                : (json["meterValues"] as Array<any>).map(
                      ChargerMeterValueDtoFromJSON,
                  ),
        nextCursor: json["nextCursor"] == null ? undefined : json["nextCursor"],
    };
}

export function TransactionMeterValuesResponseToJSON(
    value?: TransactionMeterValuesResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        meterValues:
            value["meterValues"] == null
                ? undefined
                : (value["meterValues"] as Array<any>).map(
                      ChargerMeterValueDtoToJSON,
                  ),
        nextCursor: value["nextCursor"],
    };
}
